import React, { BaseSyntheticEvent, FC, ReactNode, useMemo } from 'react';

import { Box, BoxProps, Flex, FlexProps } from '@chakra-ui/react';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

import { defaultCardStyle } from './styles';

export interface ICardStyles {
  card?: FlexProps;
  cardContent?: FlexProps;
  header?: FlexProps;
  footer?: BoxProps;
}

export interface ICard {
  headerComponent?: ReactNode;
  header?: ReactNode;
  contentComponent?: ReactNode;
  content?: ReactNode;
  footerComponent?: ReactNode;
  footer?: ReactNode;

  onClick?: (record?: any, e?: BaseSyntheticEvent) => void;
  record?: any;
  styles?: ICardStyles;
  overwriteDefaultStyles?: boolean;
  children?: React.ReactNode | React.ReactNode[];
}

export const Card: FC<ICard> = props => {
  const {
    headerComponent,
    contentComponent,
    footerComponent,
    header,
    content,
    footer,
    onClick,
    record,
    styles,
    overwriteDefaultStyles,
  } = props;

  const baseStyles = useMemo(() => {
    const props = cloneDeep(defaultCardStyle);
    return overwriteDefaultStyles ? styles : merge(props, styles);
  }, [styles, overwriteDefaultStyles]);

  // const boxShadow = useColorModeValue('0 0 30px #e4e4e4', 'none');

  const handleOnClick = React.useCallback(
    (e: BaseSyntheticEvent) => {
      onClick?.(record, e);
    },
    [record, onClick],
  );

  return (
    <Flex
      className={'card'}
      pt={headerComponent || header ? 0 : 4}
      onClick={handleOnClick}
      {...baseStyles?.card}
    >
      {(headerComponent || header) && (
        <Flex {...baseStyles?.header}>{headerComponent ?? header}</Flex>
      )}

      <Flex overflowY="auto" {...baseStyles?.cardContent}>
        {!!(contentComponent || content)
          ? contentComponent ?? content
          : props?.children}
      </Flex>

      {(footerComponent || footer) && (
        <Box {...baseStyles?.footer}>{footerComponent ?? footer}</Box>
      )}
    </Flex>
  );
};
